export default "__VITE_ASSET__C5Wq7k7U__"